<template>
  <div>
  <el-dialog
    :visible.sync="receiptNoVisible"
    v-model="receiptNoVisible"
    title="进仓单"
    :close-on-click-modal="false"
    :hide-required-asterisk="true"
    :destroy-on-close="true"
    top="8vh"  width="70%" 
  >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addRuleForm"
        auto-complete="off"
        style="overflow-x: hidden; overflow-y: hidden; margin-right: 4%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户" prop="OrgID">
              <el-select
                v-model="addForm.OrgID"
                placeholder="请选择客户"
                style="width: 100%"
               
              >
                <el-option
                  v-for="item in customerList"
                  :label="item.customName"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入库仓" prop="WarehouseId">
              <el-select
                v-model="addForm.WarehouseId"
                style="width: 100%"
                placeholder="请选择入库仓"
               
              >
                <el-option
                  v-for="item in WareHouse"
                  :label="item.warehouseName"
                  :value="item.warehouseId"
                  :key="item.warehouseId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
         
        <el-row>
          <el-col :span="12">
            <el-form-item label="参考单号" prop="OrgCustomerNo">
              <el-input
                v-model="addForm.OrgCustomerNo"
                auto-complete="off"
                placeholder="请输入参考单号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预计到仓日期" prop="EstimatedDate">
              <el-date-picker
                type="date"
                placeholder="选择预计到仓日期"
                v-model="addForm.EstimatedDate"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="Driver">
              <el-input
                v-model="addForm.Driver"
                auto-complete="off"
                placeholder="请输入联系人"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="DriverPhone">
              <el-input
                v-model="addForm.DriverPhone"
                auto-complete="off"
                placeholder="请输入联系电话"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="车牌号" prop="NumberPlate">
              <el-input
                v-model="addForm.NumberPlate"
                auto-complete="off"
                placeholder="请输入车牌号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          
        </el-row>
        <el-row>
          <el-form-item label="">     
            <el-button type="primary" plain @click="exportTemplate"  v-no-more-click v-if="addForm.TFDeliveryOrderID>0"
              >导出编辑</el-button
            >   
            <el-button type="primary" plain @click="importExport" v-no-more-click
              >导入箱明细</el-button
            >
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="">
           
          
                <el-table border   :data="tableData.filter(data => !search.toLowerCase() || data.customerBox.includes(search.toLowerCase()))"
                style="width: 100%"  max-height="350">
                  <el-table-column
                    fixed
                    prop="customerBox"
                    label="箱号"
                    align="center"
                    width="150"
                  >
                  <template slot="header" slot-scope="scope">
           <el-input
          v-model="search"
          size="mini"
          placeholder="输入箱号搜索"/>
        </template>
                  </el-table-column>
                
                  <el-table-column
                    label="毛重(kg)"
                    align="center"
                    prop="boxWeight"
                    width="100"
                  >      
                  </el-table-column>
                  <el-table-column
                    label="长(cm)"
                    align="center"
                    width="100"
                    prop="boxLength"
                  >
                  </el-table-column>
                  <el-table-column
                    label="宽(cm)"
                    align="center"
                    prop="boxWidth"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    label="高(cm)"
                    align="center"
                    prop="boxHeight"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    label="体积(cbm)"
                    align="center"
                    prop="boxVolume"
                    width="120"
                  >
                  </el-table-column>
                  <el-table-column
                    label="数量"
                    align="center"
                    prop="quantity"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    label="SKU"
                    align="center"
                    prop="skuCode"
                    width="150"
                  >
                  </el-table-column>
                  <el-table-column
                    label="中文申报名称"
                    align="center"
                    prop="declareCName"
                    width="150"
                  >
                  </el-table-column>
                  <el-table-column
                    label="英文申报名称"
                    align="center"
                    prop="declareEName"
                    width="150"
                  >
                  </el-table-column>
                  <el-table-column
                    label="是否含电"
                    align="center"
                    prop="electricity"
                    width="110"
                  >
                  </el-table-column>


                  <el-table-column label="操作" width="100"  fixed="right"   align="center">
                  
                    <template slot-scope="scope">
                      <el-button
                        @click="delboxMark(scope.row.customerBox)"
                        type="text"
                        size="small"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              
             
              <div class="block">
                <el-pagination layout="total" :total="total" style="float: right">
                </el-pagination>
              
            </div>
          </el-form-item>
        </el-row>


        <el-row type="flex" class="row-bg" justify="center">
          <el-button type="primary" @click="onAddSubmit" :loading="addLoading" v-no-more-click
            >提交</el-button
          >
        </el-row>
      </el-form>
  
      
    
  </el-dialog>

  
      <!-- 导入箱明细 -->
      <el-dialog
        :visible.sync="importVisible"
        v-model="importVisible"
        :close-on-click-modal="false"
        :hide-required-asterisk="true"
        title="导入箱明细"
        width="40%"
        style="text-align: center"
      >
        <el-form>
          <el-row type="flex" class="row-bg" style="justify-content: center">
            <el-form-item>
              <!-- 上传文件 -->
              <el-upload
                ref="upload"
                class="upload-demo"
                drag
                action="string"
                :http-request="UploadExcel"
                :limit="1"
                accept=".xls,.xlsx"
                :before-upload="onBeforeUploadExcel"
                :auto-upload="false"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  只能上传.xls,.xlsx文件
                </div>
              </el-upload>
            </el-form-item>
          </el-row>
          <!-- 上传显示进度条 -->
          <el-row type="flex" class="row-bg" style="justify-content: center">
            <el-form-item>
              <el-button type="primary" @click="handleDownload()"
                >下载导入模板</el-button
              >
            </el-form-item>
            <el-form-item style="margin-left: 40px">
              <el-button type="primary" @click="submitUpload"
                >导入箱明细</el-button
              >
            </el-form-item>
          </el-row>
          <el-row type="flex" class="row-bg" style="justify-content: center">
            <div v-show="progressFlag" class="head-img" style="width: 150px">
              <el-progress
                :text-inside="true"
                :percentage="progressPercent"
                status="success"
              ></el-progress>
            </div>
          </el-row>
          <el-row type="flex" class="row-bg" style="justify-content: center">
            <span style="color: red"> {{ Importtext }}</span>
          </el-row>
        </el-form>
      </el-dialog>
    </div>
  </template>
  
<script>
  import { getCustomerList } from "@/api/ProductSkuExcel.js";
  import {
    importTFDeliveryBox,
    addTFDelivery,
    getTFDeliveryOrderById,
    deliveryBoxInfoAsyncOut,
    downloadDeliveryBox,
} from "@/api/transfer/tfDelivery/receiptManage.js";
  
  import axios from "axios";
  export default {
    data() {
      return {

        addForm: {
          TFDeliveryOrderID: 0,
          OrgID: "",
          WarehouseId: "",
          OrgCustomerNo: "",
          EstimatedDate: "",
          Driver: "",
          DriverPhone: "",
          NumberPlate: "",    
        },
        addFormRules: {
          OrgID: [{ required: true, message: "请选择客户", trigger: "blur" }],
          WarehouseId: [
            { required: true, message: "请选择入库仓", trigger: "blur" },
          ],
         
  
          OrgCustomerNo: [
            { required: true, message: "请输入参考单号", trigger: "blur" },
            
          ],
          EstimatedDate: [
            { required: true, message: "请选择预计送仓日期", trigger: "blur" },
          ],
          Driver: [
            { required: true, message: "请输入联系人", trigger: "blur" },
          ],
          DriverPhone: [
            { required: true, message: "请输入联系方式", trigger: "blur" },
          ],
          NumberPlate: [
            { required: true, message: "请输入车牌号", trigger: "blur" },
            
          ],
        },
        
        customerList: [], //客户
        
        WareHouse: [], //仓库

        addLoading: false,
        tableData: [],
        search:"",
        total: 0,
        progressFlag: false, //进度条初始值隐藏
        progressPercent: 0, //进度条初始值
        Importtext: "", //导入返回信息
        importVisible: false,
        boxMarkVisible: false,

        pagetotal: 0,
        page: 1,
        pageSize: 20,
        receiptNoVisible: false,
      };
    },
    methods: {
    showDialog(id){
        this.receiptNoVisible = true;
        
        if(id>0){
            this.onGetDeliveryOrderTaskById(id);
        } else{
            this.addForm={}
            this.tableData = []
        }
 
    },

      //导出模板
      exportTemplate(){

      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: deliveryBoxInfoAsyncOut+
          "?deliveryOrderID=" +
          this.addForm.TFDeliveryOrderID,
        method: "get",
         
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });

      },
        
      
      //加载基础资料
      getWarebaselist() {
        let user = JSON.parse(window.localStorage.user);
        console.log(user.warehouseList);
        this.WareHouse = user.warehouseList.filter((m) => {
          return m.operateType === 0;
        });
      
      },
     
    
    
      //删除箱唛
      delboxMark(customerBox) {
        this.$confirm("确认删除箱号" + customerBox + "吗?", "提示", {}).then(() => {
          const index = this.tableData.findIndex(
            (item) => item.customerBox === customerBox
          );
          if (index > -1) {
            this.tableData.splice(index, 1);
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.total = this.tableData.length;
          } else {
            this.$message({
              message: "删除失败",
              type: "error",
            });
          }
        });
      },
      //弹出导入文件框
      importExport() {
        this.Importtext = "";
        this.importVisible = true;
      },
      //文件上传前验证
      onBeforeUploadExcel(file) {
        console.log(file);
        var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
        const extension = testmsg === "xls";
        const extension2 = testmsg === "xlsx";
        // const isLt2M = file.size / 1024 / 1024 < 10
        if (!extension && !extension2) {
          this.$message({
            message: "导入文件只能是 xls、xlsx格式!",
            type: "error",
          });
        }
        return extension || extension2;
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      //上传文件
      UploadExcel(param) {
        if (param == undefined) {
          this.$message({
            message: "请上传导入文件",
            type: "error",
          });
          return;
        }
        console.log(param, "文件");
        this.parafile = param;
        let para = new FormData();
        para.append("file", param.file);
        this.progressFlag = true;
        axios({
          url: importTFDeliveryBox ,
          method: "post",
          data: para,
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            //进度条
            this.progressPercent =
              ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          },
        })
          .then((res) => {
            this.Importtext = res.data.msg;
            console.log(this.Importtext);
            if (res.data.success) {
              this.parafile = "";
              console.log("导入成功");
              param.onError(); // 上传成功的文件会显示绿色的对勾
              this.importVisible = false;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.tableData = res.data.response;
              this.total=this.tableData.length;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
              param.onError();
            }
            this.progressFlag = false;
            this.progressPercent = 0;
          })
          .catch((error) => {
            this.progressFlag = false;
            this.progressPercent = 0;
            this.$message({
              message: "文件导入失败，请重试",
              type: "error",
            });
            param.onError();
          });
      },
      //新增
      onAddSubmit() {
        let para = Object.assign({}, this.addForm);
    
        if (this.tableData.length == 0) {
          this.$message({
            message: "请导入箱明细数据",
            type: "error",
          });
          return;
        }
       
        para.BoxInfoList = this.tableData;
  
        let _this = this;
        this.$refs.addRuleForm.validate((valid) => {
          if (valid) {
            this.$confirm("确认提交吗？", "提示", {})
              .then(() => {
                var user = JSON.parse(window.localStorage.user);
                if (!user && user.id == 0) {
                  this.$message({
                    message: "用户信息为空，先登录",
                    type: "error",
                  });
                  _this.$router.replace(
                    _this.$route.query.redirect
                      ? _this.$route.query.redirect
                      : "/"
                  );
                }
  
                this.addLoading = true;
                console.log(para);
  
                addTFDelivery(para).then((res) => {
                  this.addLoading = false;
                  console.log(res);
                  if (res.data.success) {
                    this.addForm={}
                    this.tableData = [];
                    this.total = 0;
                    this.search = "";
                    this.$alert(
                        res.data.msg ,'提交成功',
                      {
                        confirmButtonText: "确定",
                        callback: (action) => {
                          
                          window.parent.postMessage("close", "*");
                         
                        },
                      }
                    );
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                    });
                  }
                });
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
      },
      //下载模板
      handleDownload() {
        let url = downloadDeliveryBox;
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        document.body.appendChild(link);
        link.click();
      },
      //查询进仓单明细
      onGetDeliveryOrderTaskById(deliveryOrderID) {
        if (deliveryOrderID == 0 || deliveryOrderID == undefined) {
          this.$message({
            message: "进仓单ID错误",
            type: "error",
          });
          return;
        }
        console.log(deliveryOrderID)
        let pata = {
            deliveryOrderID,
        };
        getTFDeliveryOrderById(pata).then((res) => {
          if (res.data.success) {
            //this.tableData = res.data.response.boxInfoList;

            this.$set(this,"tableData", res.data.response.boxInfoList);
            this.$set(this,"total", this.tableData.length);
            this.$set(this.addForm,"TFDeliveryOrderID", res.data.response.tfDeliveryOrderID);
            this.$set(this.addForm,"OrgID", res.data.response.orgID);
            this.$set(this.addForm,"WarehouseId", res.data.response.warehouseId);
            this.$set(this.addForm,"OrgCustomerNo", res.data.response.orgCustomerNo);
            this.$set(this.addForm,"EstimatedDate", res.data.response.estimatedDate);
            this.$set(this.addForm,"Driver", res.data.response.driver);
            this.$set(this.addForm,"DriverPhone", res.data.response.driverPhone);
            this.$set(this.addForm,"NumberPlate", res.data.response.numberPlate);
           
          } else {
            this.$message({
              message: "进仓单ID错误",
              type: "error",
            });
          }
        });
      },
    },
    mounted() {
      let para = {
        IsAll: false,
      };
      getCustomerList(para).then((res) => {
        this.customerList = res.data.response;
      });
      this.getWarebaselist();
      
      var query = this.$route.query;
     
     
      if (query.warehouseId != undefined && query.orgID != undefined) {
        this.addForm.WarehouseId = parseInt(query.warehouseId);
     
        this.addForm.OrgID = parseInt(query.orgID);
       
      }
    },
     
  };
  </script>
  